import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../../../common/utils/logger';

export const onAddPinModalOpen: (
	isUpdateModal: boolean,
	source?: string,
) => AnalyticsEventPayload = (isUpdateModal: boolean, source?: string): AnalyticsEventPayload => {
	try {
		return {
			action: 'shown',
			actionSubject: isUpdateModal
				? 'aiSearchBookmarkOpenUpdateModal'
				: 'aiSearchBookmarkOpenAddModal',
			eventType: 'track',
			source,
		};
	} catch (error) {
		logger.error({ error, functionName: 'onAddPinModalOpen' });
		return {};
	}
};
